import { MoreButton } from '@design-system';
import { Core } from '@pdftron/webviewer';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { translations } from 'translations';
import { Signer } from './Signer';
import { features } from 'process';

const stageLinks = [
  {
    label: translations.COMMON.DELETE,
    value: 'delete',
  },
];

export type SignersTabProps = {
  color: string;
  isActive?: boolean;
  stages: Array<any>;
  teamFeatures?: any;
  deleteStage: (index: number) => void;
  onClickNewStage: () => void;
  onClickNewSigner: (stage: any, type: any) => void;
  handleDeleteSigner: (stage: any, index: any) => void;
  handleEditSigner: (stage: any, index: any) => void;
  handleColorChange: (stage: any, index: any) => void;
};
export const SignersTab: React.FC<SignersTabProps> = ({
  color,
  stages,
  teamFeatures,
  deleteStage,
  onClickNewStage,
  onClickNewSigner,
  handleDeleteSigner,
  handleEditSigner,
  handleColorChange,
}) => {
  const { t } = useTranslation();

  const handleNewStage = () => {
    onClickNewStage();
  };

  const handleNewSigner = (stage, type) => {
    onClickNewSigner(stage, type);
  };

  const handleStageMore = (index) => {
    if (deleteStage) deleteStage(index);
  };

  return (
    <div>
      {stages.map((stage, stageIndex) => (
        <div key={stageIndex} className="mt-8 first:mt-4">
          <div className="flex">
            <p className="mb-2 text-paragraph">
              {t(translations.COMMON.STAGE)} {stageIndex + 1}
            </p>
            <MoreButton
              className="ml-2"
              onClick={() => handleStageMore(stageIndex)}
              items={stageLinks}
            />
          </div>

          <div className="rounded-2xl border-2 border-gray-100 bg-basic-white px-4 py-5">
            {stage.signers.map(
              ({ email, name, autograph, advanced, ...rest }, signerIndex) => {
                return (
                  <Signer
                    key={signerIndex}
                    name={name}
                    email={email}
                    hasRfcValidationEnabled={
                      teamFeatures?.rfc_validation?.enabled
                    }
                    {...rest}
                    index={signerIndex}
                    stage={stageIndex}
                    autograph={autograph}
                    advanced={advanced}
                    handleDeleteSigner={handleDeleteSigner}
                    handleEditSigner={handleEditSigner}
                    color={rest.hex}
                    handleColorChange={handleColorChange}
                  />
                );
              },
            )}

            <div className="flex">
              <button
                className="mx-auto h-12 w-12 rounded-full border text-basic-white focus:outline-none"
                style={{ background: color }}
                onClick={() => handleNewSigner(stageIndex, 'signer')}
              >
                +
              </button>
            </div>
          </div>
        </div>
      ))}
      <div className="mt-4 flex w-full flex-col text-center">
        <button
          className="mx-auto h-12 w-12 rounded-full border-2 bg-basic-white focus:outline-none"
          onClick={handleNewStage}
          style={{ borderColor: color, color: color }}
        >
          +
        </button>
        <a
          href="/#"
          onClick={handleNewStage}
          className="w-full text-center"
          style={{ color: color }}
        >
          {t(translations.COMMON.NEW_STAGE)}
        </a>
      </div>
    </div>
  );
};
